const pluginTypes = {
  COMPONENT: 'component',
  COURSE: 'course',
  LESSON: 'lesson',
  PATHWAY: 'pathway',
  SCREEN: 'screen',
  UNIT: 'unit',
  APP: 'app',
  ETEXT: 'eText',
  OTHER: 'other',
};

export const typeConstants = {
  PLACEHOLDER: 'stage-element-placeholder',
  TEXT: 'stage-element-text',
  IMAGE: 'stage-element-image',
  PLUGIN: 'stage-element-component-plugin',
  EMBED: 'stage-element-embedded-html',
  TABLE: 'stage-element-table',
};

export const typeLabels = {
  SECTION: 'section',
  TEXT: 'text',
  IMAGE: 'image',
  TABLE: 'table',
  BLOCK: 'block',
  SHOWHIDE: 'show/hide',
};

export const otherMenuItems = {
  IMPORT: 'import',
};

export const DynamicTextType = 'plugin-dynamic-text';
export const DynamicTextTypeV2 = "plugin-dynamic-text-v2";

export default pluginTypes;
